module.exports = __webpack_public_path__ + "media/fonts/SFProText-Light-38669dc9c0f8e9a1db9018ff17d9f93b.woff";